module.exports = __webpack_public_path__ + "img/abrasive.81a84ae2.png";